import { render } from "./setapp_image.vue?vue&type=template&id=10d800f4&scoped=true"
import script from "./setapp_image.vue?vue&type=script&lang=js"
export * from "./setapp_image.vue?vue&type=script&lang=js"

import "./setapp_image.vue?vue&type=style&index=0&id=10d800f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d800f4"]])

export default __exports__